export const Invoicing = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_3622_4578)">
        <path
          d="M3 20.25V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H20.25C20.4489 4.5 20.6397 4.57902 20.7803 4.71967C20.921 4.86032 21 5.05109 21 5.25V20.25L18 18.75L15 20.25L12 18.75L9 20.25L6 18.75L3 20.25Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip1_3622_4578)">
          <path
            d="M11.5 8.34375V9.1875"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5 14.8125V15.6562"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.4688 10.5938C13.4688 10.4091 13.4324 10.2262 13.3617 10.0556C13.291 9.88499 13.1875 9.72996 13.0569 9.59938C12.9263 9.4688 12.7713 9.36522 12.6006 9.29454C12.43 9.22387 12.2472 9.1875 12.0625 9.1875H10.9375C10.5645 9.1875 10.2069 9.33566 9.94313 9.59938C9.67941 9.8631 9.53125 10.2208 9.53125 10.5938C9.53125 10.9667 9.67941 11.3244 9.94313 11.5881C10.2069 11.8518 10.5645 12 10.9375 12H12.3438C12.7167 12 13.0744 12.1482 13.3381 12.4119C13.6018 12.6756 13.75 13.0333 13.75 13.4062C13.75 13.7792 13.6018 14.1369 13.3381 14.4006C13.0744 14.6643 12.7167 14.8125 12.3438 14.8125H10.6562C10.2833 14.8125 9.9256 14.6643 9.66188 14.4006C9.39816 14.1369 9.25 13.7792 9.25 13.4062"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3622_4578">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_3622_4578">
          <rect
            width="9"
            height="9"
            fill="white"
            transform="translate(7 7.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
